const data = {
	"width": 256,
	"height": 256,
	"body": "<path fill=\"currentColor\" d=\"M96 252a13.4 13.4 0 0 1-5.5-1.3a12.1 12.1 0 0 1-6.3-13.1l14-70l-54.4-20.4a11.9 11.9 0 0 1-7.5-8.5a12.1 12.1 0 0 1 2.9-10.9l112-120a12.2 12.2 0 0 1 14.3-2.5a12.1 12.1 0 0 1 6.3 13l-14 70l54.4 20.4a11.9 11.9 0 0 1 7.5 8.5a12.3 12.3 0 0 1-2.9 11l-112 120A12.2 12.2 0 0 1 96 252ZM69 131l47.2 17.7a12.2 12.2 0 0 1 7.6 13.6l-7.7 38.6l70.9-76l-47.2-17.7a12.1 12.1 0 0 1-7.6-13.6l7.7-38.6Z\"/>"
};
export default data;
